import { motion } from "framer-motion";
import { EASE, Reveal } from "@/components/site/motion";

const SECTIONS = [
  {
    title: "What I collect",
    text: "When you use the contact form, I collect the details you choose to share: your name, company, email address, company website, and a description of the challenge you're facing. If you book time through the calendar link, scheduling is handled by Calendly under its own privacy policy.",
  },
  {
    title: "How it's used",
    text: "Your details are used for one purpose only: to read your enquiry and reply to you directly, typically within one business day. Your information is never sold, rented, or shared with third parties for marketing, and you will not be added to a mailing list.",
  },
  {
    title: "How it's stored",
    text: "Enquiries are delivered to my business email inbox and stored in a secured database operated by the site's hosting provider. Access is limited to me.",
  },
  {
    title: "Your choices",
    text: "You can ask at any time to see, correct, or delete the information you've sent. Email info@rhondajohnson.co and it will be taken care of promptly.",
  },
];

export default function Privacy() {
  return (
    <>
      <section className="page-hero" data-testid="privacy-hero">
        <div className="wrap">
          <motion.span
            className="kicker"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: EASE }}
          >
            Privacy
          </motion.span>
          <h1 style={{ fontSize: "clamp(2rem, 3.6vw, 2.9rem)" }} data-testid="privacy-heading">
            <span className="mask-line">
              <motion.span
                className="mask-inner"
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
              >
                A short, plain privacy note.
              </motion.span>
            </span>
          </h1>
          <motion.p
            className="lede"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.35, ease: EASE }}
          >
            This site exists to start conversations. It collects as little as possible to do that well.
          </motion.p>
        </div>
      </section>

      <section data-testid="privacy-body">
        <div className="wrap" style={{ maxWidth: "780px" }}>
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} y={20} delay={i * 0.04} data-testid={`privacy-section-${i}`}>
              <h3 style={{ marginBottom: "0.5rem" }}>{s.title}</h3>
              <p className="muted" style={{ maxWidth: "68ch" }}>{s.text}</p>
              {i < SECTIONS.length - 1 && <hr style={{ border: "none", borderTop: "1px solid var(--line)", margin: "2rem 0" }} />}
            </Reveal>
          ))}
          <Reveal y={16}>
            <p className="form-note" data-testid="privacy-updated" style={{ marginTop: "2rem" }}>
              Last updated: September 2026. Questions: <a href="mailto:info@rhondajohnson.co">info@rhondajohnson.co</a>
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
